export default "__VITE_ASSET__Du2j3F7F__"